const setBusinessProcesses = (state, payload) => {
  state.businessProcesses = payload;
};

const setSelectedBusinessProcesses = (state, payload) => {
  state.selectedBusinessProcesses = payload;
};

const setCustomizedBusinessProcesses = (state, payload) => {
  state.customizedBusinessProcesses = payload;
};

export default {
  setBusinessProcesses,
  setSelectedBusinessProcesses,
  setCustomizedBusinessProcesses
};
